var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 0.049,
    x2: -0.382,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 0.5,
    x2: -1.306,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.863,
    y1: 0.179,
    x2: -0.502,
    y2: 1.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: -0.54,
    x2: 0.421,
    y2: 0.249,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-play-badge",
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 135,
    height: 40,
    rx: 5,
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M130,40H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H130a5.006,5.006,0,0,1,5,5V35A5.006,5.006,0,0,1,130,40ZM5,.8A4.205,4.205,0,0,0,.8,5V35A4.205,4.205,0,0,0,5,39.2H130a4.205,4.205,0,0,0,4.2-4.2V5A4.205,4.205,0,0,0,130,.8Z",
    transform: "translate(10 10)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.069,3.38a2.72,2.72,0,0,1-.75,2,2.9,2.9,0,0,1-2.2.88,3,3,0,0,1-2.21-.9A3.19,3.19,0,0,1,.909.9,3.16,3.16,0,0,1,4.349.25a2.54,2.54,0,0,1,.94.67l-.53.53A2,2,0,0,0,3.119.73,2.4,2.4,0,1,0,4.8,4.86a1.92,1.92,0,0,0,.5-1.22H3.119V2.92h2.91a3.75,3.75,0,0,1,.04.46Z",
    transform: "translate(51.351 16.86)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M3.48.74H.78v1.9H3.24v.72H.78v1.9h2.7V6H0V0H3.48Z",
    transform: "translate(58.52 17)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M2.45,6H1.68V.74H0V0H4.17V.74H2.45Z",
    transform: "translate(62.83 17)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M.115,6V0h.77V6Z",
    transform: "translate(69.825 17)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M2.45,6H1.68V.74H0V0H4.12V.74H2.45Z",
    transform: "translate(71.68 17)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3.08,6.263a3.091,3.091,0,0,1-2.2-.912A3.245,3.245,0,0,1,.88.911,2.942,2.942,0,0,1,3,0h.122A3.019,3.019,0,0,1,5.28.911a3.092,3.092,0,0,1,.88,2.22,3.015,3.015,0,0,1-.88,2.22A3.134,3.134,0,0,1,3.08,6.263ZM3.08.73a2.3,2.3,0,0,0-1.63.681,2.54,2.54,0,0,0,0,3.44,2.29,2.29,0,0,0,3.26,0,2.54,2.54,0,0,0,0-3.44A2.3,2.3,0,0,0,3.08.73Z",
    transform: "translate(78.33 16.869)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M0,6V0H.93L3.85,4.67h0V0h.77V6h-.8L.77,1.11h0V6Z",
    transform: "translate(85.58 17)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M36.428,16.955h-.053a3.98,3.98,0,0,1-3.717-2.52l1.62-.67a2.35,2.35,0,0,0,2.15,1.51c1.442,0,2.27-.911,2.27-2.5v-.609h-.07a2.879,2.879,0,0,1-2.182,1h-.058a4.26,4.26,0,0,1,0-8.51h.031a2.941,2.941,0,0,1,2.209,1h.07v-.7h1.73v7.57a4.572,4.572,0,0,1-1.179,3.392A3.914,3.914,0,0,1,36.428,16.955Zm.12-10.572h0a2.58,2.58,0,0,0,0,5.151,2.38,2.38,0,0,0,2.28-2.58,2.39,2.39,0,0,0-2.28-2.57Zm43.28,10.362h-1.95l1.9-4.21-3.33-7.58h2l2.22,5.42h.06l2.139-5.42h2.081l-5.12,11.789Zm-31.06-3.52a4.151,4.151,0,0,1-1.236-.185,4.229,4.229,0,0,1-2.994-4.085,4,4,0,0,1,3.99-4.25h.01a4.023,4.023,0,0,1,3.64,2.71l.211.44-5.69,2.35A2.147,2.147,0,0,0,48.667,11.5l.088,0h.024a2.423,2.423,0,0,0,2.068-1.17l1.45,1A4.218,4.218,0,0,1,48.767,13.225Zm-.059-6.883-.1,0a2.341,2.341,0,0,0-2.23,2.49l3.8-1.58A1.629,1.629,0,0,0,48.708,6.342ZM27.287,13.225h-.012a4.26,4.26,0,0,1-.008-8.519h.08A4.163,4.163,0,0,1,30.3,5.925a4.307,4.307,0,0,1-.008,6.044A4.232,4.232,0,0,1,27.287,13.225Zm-.2-6.843A2.588,2.588,0,0,0,25.2,7.2a2.562,2.562,0,0,0-.439,2.869,2.591,2.591,0,0,0,2.327,1.468,1.683,1.683,0,0,0,.181-.006,2.459,2.459,0,0,0,2.4-2.58,2.563,2.563,0,0,0-1.639-2.4A2.474,2.474,0,0,0,27.088,6.382Zm-9.122,6.843h-.012a4.26,4.26,0,0,1-.008-8.519h.08a4.167,4.167,0,0,1,2.956,1.22,4.281,4.281,0,0,1-3.017,7.3Zm-.2-6.843a2.58,2.58,0,0,0,0,5.16,1.78,1.78,0,0,0,.181-.006,2.461,2.461,0,0,0,2.4-2.58,2.566,2.566,0,0,0-1.639-2.4A2.5,2.5,0,0,0,17.768,6.382ZM6.609,13.22A6.61,6.61,0,0,1,6.609,0c.088,0,.175,0,.258.005h.1A6.259,6.259,0,0,1,11.4,1.825L10.127,3.1A4.614,4.614,0,0,0,6.919,1.8H6.847a4.8,4.8,0,0,0,0,9.6c.039,0,.088,0,.187,0a4.448,4.448,0,0,0,3.153-1.323,3.834,3.834,0,0,0,1-2.271H6.867v-1.8h6.08a6.1,6.1,0,0,1,.09,1.12,5.97,5.97,0,0,1-1.561,4.23A6.1,6.1,0,0,1,7.11,13.219c-.07,0-.139,0-.24,0S6.694,13.22,6.609,13.22Zm65.236-.036a2.891,2.891,0,0,1-2.887-2.759c0-1.831,1.855-2.82,3.6-2.82h.005a4.191,4.191,0,0,1,1.945.48v-.12a1.8,1.8,0,0,0-1.792-1.622,1.682,1.682,0,0,0-.209.012c-.045,0-.092-.006-.153-.006a1.782,1.782,0,0,0-1.557.916l-1.65-.689a3.473,3.473,0,0,1,3.115-1.917c.087,0,.156,0,.215.006l.04.021c2.267,0,3.791,1.39,3.791,3.46v4.81h-1.8v-1h-.06a2.637,2.637,0,0,1-2.232,1.225c-.041,0-.083,0-.122,0h-.025C71.991,13.181,71.918,13.184,71.844,13.184Zm1.023-4.07h-.081c-.967,0-2,.352-2,1.34,0,.772.9,1.059,1.46,1.059l.04.021a2.268,2.268,0,0,0,2.2-2A3.338,3.338,0,0,0,72.868,9.114Zm-14.54,3.84h-1.87V.455h4.48c.125-.007.209-.01.28-.01a3.89,3.89,0,0,1,3.32,5.915,3.912,3.912,0,0,1-3.321,1.865c-.083,0-.172,0-.279-.01h-2.61v4.739Zm0-10.76v4.26h2.61l.04.02a2.14,2.14,0,0,0,0-4.28Zm-14.7,10.76H41.757V.455h1.869v12.5Zm24.3,0H66.067V.455h1.859v12.5Z",
    transform: "translate(50.873 27.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M.474.07A2,2,0,0,0,0,1.47V23.59a1.94,1.94,0,0,0,.47,1.4l.07.08,12.39-12.39v-.3L.544,0Z",
    transform: "translate(19.966 17.47)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    d: "M4.1,8.56,0,4.43v-.3L4.1,0l.09.06L9.1,2.84c1.4.79,1.4,2.09,0,2.89L4.21,8.51Z",
    transform: "translate(32.9 25.72)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    d: "M16.68,4.22,12.46,0,0,12.46a1.62,1.62,0,0,0,2.07.07L16.68,4.22",
    transform: "translate(20.44 30)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    d: "M16.68,8.648,2.07.348A1.61,1.61,0,0,0,0,.408l12.46,12.46Z",
    transform: "translate(20.44 17.132)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    d: "M16.56,0,2.07,8.25a1.66,1.66,0,0,1-2,0h0L0,8.32H0l.07.08h0a1.66,1.66,0,0,0,2,0L16.68.09Z",
    transform: "translate(20.44 34.13)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    d: "M.673,1.41A2,2,0,0,1,.233,0V.15A1.94,1.94,0,0,0,.7,1.55l.07-.07Z",
    transform: "translate(19.767 40.91)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    d: "M5,1.3,0,4.13l.09.09L5,1.44A1.75,1.75,0,0,0,6.06,0h0A1.86,1.86,0,0,1,5,1.3Z",
    transform: "translate(37 30)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    d: "M2.54.48,22.03,11.56a1.86,1.86,0,0,1,1.06,1.3h0a1.75,1.75,0,0,0-1.06-1.44L2.54.34C1.15-.46,0,.2,0,1.8v.15C.03.35,1.15-.31,2.54.48Z",
    transform: "translate(19.97 17.14)",
    fill: "#fff",
    opacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.e2e068cc64bc69f12a252540023b51a5.svg";
export { ForwardRef as ReactComponent };